import RessourceEntity from "../../Entities/RessourceEntity.tsx";
import "./Video.module.css";

/**
 * Composante React représentant un lecteur vidéo avec des fonctionnalités de contrôle.
 *
 * @param {string} url L'URL de la vidéo à afficher.
 * @param {boolean} telechargeable Indique si la vidéo est téléchargeable ou non.
 * @param {string} soustitre URI des sous_titres
 * @returns {JSX.Element} Un élément JSX représentant le lecteur vidéo.
 */
const CapsuleVideo = ({ url, telechargeable, soustitre }: RessourceEntity) => {
  return (
    <>
      <video
        controls
        controlsList={!telechargeable ? "nodownload" : ""}
        name="media"
      >
        <source src={url} type="video/mp4" />
        <track default kind="subtitles" srcLang="fr" src={soustitre} />
      </video>
    </>
  );
};

export default CapsuleVideo;
